// frontend/src/services/citaService.js
import api from './api';

const citaService = {
  // Obtener todas las citas con filtros
  getCitas: async (params = {}) => {
    return await api.get('/citas', { params });
  },

  // Obtener cita por ID
  getCita: async (id) => {
    return await api.get(`/citas/${id}`);
  },

  // Crear nueva cita
  createCita: async (citaData) => {
    return await api.post('/citas', citaData);
  },

  createCitaGrupal: async (citaData) => {
    try {
       const response = await api.post('/citas/grupal', citaData);
      return response;
    } catch (error) {
      console.error('❌ Error en createCitaGrupal:', error);
      throw error;
    }
  },
  
  // Actualizar cita
  updateCita: async (id, citaData) => {
    return await api.put(`/citas/${id}`, citaData);
  },

  deleteCita: async (id) => {
    return await api.delete(`/citas/${id}`);
  },

  // Enviar recordatorio manual
  enviarRecordatorio: async (id) => {
    return await api.post(`/citas/${id}/recordatorio`);
  },

  // Obtener citas para el calendario (agrupadas por fecha)
  getCalendarioCitas: async (fechaInicio, fechaFin, params = {}) => {
    const queryParams = {
      fecha_inicio: fechaInicio,
      fecha_fin: fechaFin,
      ...params
    };

    return await api.get('/citas/calendario', { params: queryParams });
  },

  getSesionesEtapa: async (pacienteId, especialidadId, etapaId) => {
    try {
      const response = await api.get('/sesiones-etapa', {
        params: {
          paciente_id: pacienteId,
          especialidad_id: especialidadId,
          etapa_id: etapaId
        }
      });
      return response;
    } catch (error) {
      console.error('Error al obtener información de sesiones por etapa:', error);
      // Devolver un objeto predeterminado en caso de error
      return { data: { count: 0 } };
    }
  },

  getHistorialSesionesEtapa: async (pacienteId, etapaId) => {
    try {
      const response = await api.get(`/sesiones-etapa/pacientes/${pacienteId}/etapas/${etapaId}`);
      return response;
    } catch (error) {
      console.error('Error al obtener historial de sesiones:', error);
      return { data: [] };
    }
  },
  
  // Obtener citas por paciente ID (NUEVO)
  getCitasByPaciente: async (pacienteId) => {
    if (!pacienteId) {
      console.error("ID de paciente no proporcionado");
      return { data: [] };
    }
    
    try {
      // Intento 1: Ruta directa /citas/paciente/:id
      const response = await api.get(`/citas/paciente/${pacienteId}`);
      return response;
    } catch (error) {
      console.warn('Error en ruta directa de citas por paciente, intentando alternativa...');
      
      try {
        // Intento 2: Ruta con parámetros
        const response = await api.get('/citas', { 
          params: { paciente_id: pacienteId } 
        });
        return response;
      } catch (secondError) {
        console.error('Error al obtener citas por paciente:', secondError);
        return { data: [] };
      }
    }
  },
  
  // Obtener citas por historia clínica (NUEVO)
  getCitasByHistoria: async (historiaId) => {
    if (!historiaId) {
      console.error("ID de historia clínica no proporcionado");
      return { data: [] };
    }
    
    try {
      // Intento 1: Ruta directa /citas/historia/:id
      const response = await api.get(`/citas/historia/${historiaId}`);
      return response;
    } catch (error) {
      console.warn('Error en ruta directa de citas por historia, intentando alternativa...');
      
      try {
        // Intento 2: Ruta con parámetros
        const response = await api.get('/citas', { 
          params: { historia_id: historiaId } 
        });
        return response;
      } catch (secondError) {
        console.error('Error al obtener citas por historia:', secondError);
        return { data: [] };
      }
    }
  },

  // Obtener especialistas disponibles
  getEspecialistas: async () => {
    return await api.get('/especialistas');
  },

  // Obtener especialidades disponibles
  getEspecialidades: async () => {
    return await api.get('/especialidades');
  },
  
  // Obtener pacientes para selector
  getPacientes: async (search = '') => {
    return await api.get('/pacientes', {
      params: { 
        limit: 100,
        search,
        estado: 'Activo'
      }
    });
  },

 // Crear múltiples citas
  createMultiplesCitas: async (citaData) => {
    return await api.post('/citas/multiples', citaData);
  },

  createMultiplesCitasConHorarios: async (data) => {
    try {
      
      const response = await api.post('/citas/multiples-horarios', data);
      return response;
    } catch (error) {
      console.error('❌ Error creando múltiples citas con horarios:', error);
      throw error;
    }
  },

  // Verificar disponibilidad para múltiples fechas
  verificarDisponibilidadMultiple: async (data) => {
    return await api.post('/citas/verificar-disponibilidad-multiple', data);
  },

  // Obtener datos de cita para reprogramar
  getCitaParaReprogramar: async (id) => {
    return await api.get(`/citas/${id}/reprogramar`);
  },
 
// Obtener datos de cita para reprogramar
getCitaParaReprogramar: async (id) => {
  return await api.get(`/citas/${id}/reprogramar`);
},

// Cambiar estado de cita
cambiarEstado: async (citaId, nuevoEstado) => {
  try {
    const response = await api.patch(`/citas/${citaId}/estado`, {
      estado: nuevoEstado
    });
    return response.data;
  } catch (error) {
    console.error('Error cambiando estado:', error);
    throw error;
  }
},

// Reprogramar cita individual
reprogramarCita: async (citaId, nuevaInfo) => {
  try {
    const response = await api.put(`/citas/${citaId}/reprogramar`, {
      nueva_fecha: nuevaInfo.nuevaFecha,
      nueva_hora_inicio: nuevaInfo.nuevaHoraInicio,
      nueva_hora_fin: nuevaInfo.nuevaHoraFin,
      motivo_cambio: nuevaInfo.motivoCambio
    });
    return response.data;
  } catch (error) {
    console.error('Error reprogramando cita:', error);
    throw error;
  }
},

// Reprogramar cita recurrente
reprogramarCitaRecurrente: async (citaId, nuevaInfo, accion) => {
  try {
    const response = await api.put(`/citas/${citaId}/reprogramar-serie`, {
      nueva_fecha: nuevaInfo.nuevaFecha,
      nueva_hora_inicio: nuevaInfo.nuevaHoraInicio,
      nueva_hora_fin: nuevaInfo.nuevaHoraFin,
      motivo_cambio: nuevaInfo.motivoCambio,
      accion: accion === true ? 'solo_esta' : 'todas_futuras' // true = confirmButton, false/null = denyButton
    });
    return response.data;
  } catch (error) {
    console.error('Error reprogramando serie:', error);
    throw error;
  }
},

// Eliminar cita individual (alias para deleteCita existente)
eliminarCita: async (citaId) => {
  try {
    return await api.delete(`/citas/${citaId}`);
  } catch (error) {
    console.error('Error eliminando cita:', error);
    throw error;
  }
},

// Eliminar cita recurrente
eliminarCitaRecurrente: async (citaId, accion) => {
  try {
    const response = await api.delete(`/citas/${citaId}/serie`, {
      data: { 
        accion: accion === true ? 'solo_esta' : 'todas_futuras'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error eliminando serie:', error);
    throw error;
  }
},

// Obtener información de serie de citas recurrentes
getSerieRecurrente: async (serieId) => {
  try {
    const response = await api.get(`/citas/serie/${serieId}`);
    return response.data;
  } catch (error) {
    console.error('Error obteniendo serie recurrente:', error);
    throw error;
  }
},

// Crear citas recurrentes
createCitasRecurrentes: async (citaData) => {
  try {
    const response = await api.post('/citas/recurrentes', citaData);
    return response.data;
  } catch (error) {
    console.error('Error creando citas recurrentes:', error);
    throw error;
  }
},

// Gestionar toda una serie de citas recurrentes
gestionarSerie: async (serieId, accion, data = {}) => {
  try {
    const response = await api.put(`/citas/serie/${serieId}`, {
      accion, // 'pausar', 'reanudar', 'modificar', 'eliminar'
      ...data
    });
    return response.data;
  } catch (error) {
    console.error('Error gestionando serie:', error);
    throw error;
  }
},

// Verificar conflictos al reprogramar
verificarConflictos: async (citaId, nuevaFecha, nuevaHoraInicio, nuevaHoraFin, especialistaId) => {
  try {
    const response = await api.post('/citas/verificar-conflictos', {
      cita_id: citaId,
      nueva_fecha: nuevaFecha,
      nueva_hora_inicio: nuevaHoraInicio,
      nueva_hora_fin: nuevaHoraFin,
      especialista_id: especialistaId
    });
    return response.data;
  } catch (error) {
    console.error('Error verificando conflictos:', error);
    throw error;
  }
},

// Obtener historial de cambios de una cita
getHistorialCambios: async (citaId) => {
  try {
    const response = await api.get(`/citas/${citaId}/historial`);
    return response.data;
  } catch (error) {
    console.error('Error obteniendo historial:', error);
    throw error;
  }
},

// Reprogramar cita individual (VERSIÓN MEJORADA)
reprogramarCita: async (citaId, nuevaInfo) => {
  try {
    // Primero verificar conflictos
    const conflictos = await citaService.verificarConflictos(
      citaId, 
      nuevaInfo.nuevaFecha, 
      nuevaInfo.nuevaHoraInicio, 
      nuevaInfo.nuevaHoraFin,
      nuevaInfo.especialistaId
    );
    
    if (conflictos.tieneConflictos) {
      throw new Error(`Conflicto detectado: ${conflictos.mensaje}`);
    }
    
    const response = await api.put(`/citas/${citaId}/reprogramar`, {
      nueva_fecha: nuevaInfo.nuevaFecha,
      nueva_hora_inicio: nuevaInfo.nuevaHoraInicio,
      nueva_hora_fin: nuevaInfo.nuevaHoraFin,
      motivo_cambio: nuevaInfo.motivoCambio
    });
    return response.data;
  } catch (error) {
    console.error('Error reprogramando cita:', error);
    throw error;
  }
},

esCitaRecurrente: async (citaId) => {
  try {
    const response = await api.get(`/citas/${citaId}/es-recurrente`);
    return response.data;
  } catch (error) {
    console.error('Error verificando si es recurrente:', error);
    return { esRecurrente: false };
  }
},

// Eliminar cita y todas las posteriores
eliminarCitaYPosteriores: async (citaId) => {
  try {
     
    const response = await api.delete(`/citas/${citaId}/posteriores`);
    
     
    return response.data;
  } catch (error) {
    console.error('❌ SERVICE: Error en eliminación:', {
      status: error.response?.status,
      statusText: error.response?.statusText,
      data: error.response?.data,
      message: error.message,
      url: error.config?.url,
      method: error.config?.method
    });
    
    throw error;
  }
},

contarCitasPosteriores: async (citaId) => {
  try {
    const response = await api.get(`/citas/${citaId}/contar-posteriores`);
    return response.data;
  } catch (error) {
    console.error('Error contando citas posteriores:', error);
    throw error;
  }
},
// Obtener pacientes para citas grupales
getPacientesParaCitasGrupales: async (params = {}) => {
  try {
    const response = await api.get('/citas/pacientes-grupales', { params });
    return response;
  } catch (error) {
    console.error('Error obteniendo pacientes para citas grupales:', error);
    throw error;
  }
},

// Crear citas grupales recurrentes
crearCitasGrupalesRecurrentes: async (citaData) => {
  try {
    const response = await api.post('/citas/grupales-recurrentes', citaData);
    return response;
  } catch (error) {
    console.error('Error creando citas grupales recurrentes:', error);
    throw error;
  }
},

// Obtener programas filtrados (si no existe)
obtenerProgramasFiltrados: async (params = {}) => {
  try {
    const response = await api.get('/citas/programas-filtrados', { params });
    return response;
  } catch (error) {
    console.error('Error obteniendo programas filtrados:', error);
    throw error;
  }
},

};

export default citaService;